module.exports = __webpack_public_path__ + "img/home.bae5e018.png";